module.exports = __webpack_public_path__ + "img/Screenshot_2021-10-28-16-24-10-081_com.pinkcoffee.sexbattle.163393c1.jpg";